import script from "./workArea.vue?vue&type=script&setup=true&lang=js"
export * from "./workArea.vue?vue&type=script&setup=true&lang=js"

import "./workArea.vue?vue&type=style&index=0&id=eccd396a&lang=css"

const __exports__ = script;

export default __exports__